import moment from "moment";
import React, { useState } from "react";
import { Link, Switch, Route, useHistory, useParams } from "react-router-dom";
import pluralize from "pluralize";
import {
  Menu,
  Dropdown,
  DatePicker,
  Card,
  Row,
  Statistic,
  Progress,
} from "antd";

import {
  AiOutlineDown,
  AiOutlineReload,
  AiOutlineBarChart,
  AiOutlineEllipsis,
} from "react-icons/ai";

import {
  stringifyDate,
  useListData,
  useToggle,
  usePet,
  useShift,
} from "../../modules";

import Ward from "../../components/drawers/ward";

const { RangePicker } = DatePicker;
let department = "OPD";

const WardCard = ({ bgColour, ward, total, admissions, occupancy }) => (
  <Card
    hoverable
    style={{
      position: "relative",
      width: 220,
      height: 190,
      borderRadius: 10,
      backgroundColor: bgColour,
      marginRight: 20,
      marginLeft: -8,
      marginBottom: 16,
    }}
  >
    <h4 className="flex items-center space-x-2 text-gray-800">
      <AiOutlineBarChart style={{ fontSize: 20 }} />

      <span className="whitespace-nowrap">{ward.name}</span>

      <a
        className="ant-dropdown-link"
        style={{ position: "absolute", right: 10, top: 20 }}
      >
        <Link to={`/app/inpatient/wards/${ward._id}`}>
          <button>
            <AiOutlineEllipsis style={{ fontSize: 20, color: "black" }} />
          </button>
        </Link>
      </a>
    </h4>

    <Row style={{ flex: "auto", display: "flex", marginTop: 5 }}>
      <Statistic
        title="Total"
        valueStyle={{ color: "#FFFFFF" }}
        style={{ marginRight: 80 }}
        value={total}
      />
    </Row>

    <span>
      In the Last one week {admissions} {pluralize("patient", admissions)}{" "}
      admitted
    </span>

    <div style={{ position: "absolute", bottom: 1, left: 10, right: 10 }}>
      <Progress
        percent={occupancy}
        strokeColor="#58ce7a"
        trailColor="#FFFFFF"
        style={{
          marginTop: "10px",
          marginBottom: "10px",
          bottom: 0,
          left: 0,
          width: 150,
        }}
      />
    </div>
  </Card>
);

const Wards = () => {
  const [wards, setWards] = useState([]);
  const [ranges, setRanges] = useState();
  const [chosen, setChosen] = useState([]);
  const [categories, setCategories] = useState([]);
  const [ptnt, setPatient] = useState();
  const [string, setString] = useState("");
  const [category, setCategory] = useState("");
  const [selected, setSelected] = useState("");

  const history = useHistory();

  const [visible, toggleVisible] = useToggle(true);

  const [select, toggleSelect] = useToggle();

  const [Shifts, ShiftsModal] = useShift(department);

  const [, getWards] = usePet(
    "wards",
    { active: true, limit: 50 },
    {
      notify: true,
      callback: ({ data }) => {
        let wrds = [data.wards];
        setWards(wrds);

        if (wrds.length > 0) setWards(wrds[0]);
      },
    }
  );

  const refresh = () => {
    getWards();
  };

  const search = (str) => {
    setString(str);
    refresh();
  };

  return (
    <div className="px-4 sm:px-6 lg:px-8 py-8 w-full max-w-9xl mx-auto">
      <div className="px-6 sm:px-8 lg:px-10 py-10 max-w-8xl mx-auto my-6 bg-white">
        <div>
          <Row
            gutter={{
              xs: 8,
              sm: 16,
              md: 24,
              lg: 32,
            }}
            justify="center"
            style={{ flex: "auto", justifyContent: "center" }}
          >
            {wards.map((ward) => (
              <WardCard
                ward={ward}
                admissions={ward.recentAdmissions ?? 0}
                bgColour="#18A375"
                occupancy={ward.occupancy ?? 0}
                total={ward.totalBeds ?? 0}
              />
            ))}
          </Row>
        </div>
      </div>

      <Switch>
        <Route path="/app/inpatient/wards/:id">
          <Ward />
        </Route>
      </Switch>
    </div>
  );
};

export default Wards;
